const isOriginLayout = (blockElementId, destinationBlockId) => {
  const idPrefix = blockElementId.substring(0, blockElementId.lastIndexOf('-'));
  return destinationBlockId.includes(idPrefix);
};

export default isOriginLayout;
